module.exports = __webpack_public_path__ + "static/media/app_hehuoren.fb42cce1.png";